/**
 * Validates if license plate starts with a letter.
 * This is a common format check for European license plates.
 *
 * @param {string | undefined | null} licensePlate - The license plate string to validate
 * @returns {boolean} true if valid (starts with letter) or empty, false if invalid format
 */
export const startsWithLetter = (licensePlate) => {
  if (!licensePlate) return true; // Empty is "valid" (optional field)
  const trimmed = licensePlate.trim();
  if (trimmed.length === 0) return true;
  return /^[A-Za-z]/.test(trimmed);
};
